export class Matricula {
    constructor(
        public _id: String,
        public codigoE: String,
        public codigoC: String,
        public periodo:String,
        public estado: number
    ) { }
}
